import React, { Component } from 'react';

import Popout from './popout';

export default class PromptPopout extends Component {
    static defaultProps = {
        className: 'small no-arrow',
        confirmText: 'Confirm',
        confirmClassName: 'btn-success',
        cancelText: 'Cancel',
        cancelClassName: 'btn-secondary'
    };

    handleCancelClick = () => {
        this.popoutCtrl.hide();
    }

    handleConfirmClick = () => {
        this.popoutCtrl && this.popoutCtrl.hide();

        this.originalClickHandler();
    }

    handleChildClick(originalClickHandler, event, ...args) {
        event.persist();
        this.popoutCtrl.show(event);

        this.originalClickHandler = originalClickHandler;
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleChildClick.bind(this, child.props.onClick)
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Popout
                    provideController={ctrl => {this.popoutCtrl = ctrl}}
                    className={this.props.className}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    cursorPosition={this.props.cursorPosition}
                    onShow={this.props.onShow}
                    onHide={this.props.onHide}
                >
                    <div className="popout-head">
                        {this.props.title}
                    </div>

                    <div className="popout-main">
                        <div className="popout-body">
                            {this.props.text}
                        </div>
                    </div>

                    <div className="popout-foot">
                        <div className="btn-group">
                            <button className={'btn btn-small ' + this.props.cancelClassName} onClick={this.handleCancelClick}>{this.props.cancelText}</button>

                            <button className={'btn btn-small ' + this.props.confirmClassName} onClick={this.handleConfirmClick}>{this.props.confirmText}</button>
                        </div>
                    </div>
                </Popout>
            </React.Fragment>
        )
    }
}
